import { __assign } from "tslib";
import React from 'react';
import { TextField } from '@mui/material';
import { colors } from '../../theme';
import { styled } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
var MyAutocomplete = styled(Autocomplete)({
    backgroundColor: colors.white,
    fontFamily: 'IBM Plex Sans',
    fontSize: '12px',
    color: colors.gray[90],
    borderColor: colors.gray[20],
    // minHeight: '37px',
    //paddingRight: multiline ? '4px' : 'default',
    '&:hover': {
        backgroundColor: colors.blue[5],
        borderColor: colors.gray[20],
        borderWidth: '0px',
        border: 'none'
    },
    '&:disabled': {
        borderColor: colors.gray[20],
        color: colors.gray[30]
    },
    '&.Mui-focused fieldset': {
        borderColor: colors.blue[40] + ' !important',
        borderWidth: '1px !important',
        //border: 'inherited',
        boxShadow: 'none'
    },
    overflowY: 'auto',
    '*::-webkit-scrollbar': {
        width: '4px'
    },
    '*::-webkit-scrollbar-track': {
        backgroundColor: colors.gray[10],
        borderRadius: '3px'
    },
    '*::-webkit-scrollbar-thumb': {
        backgroundColor: colors.gray[50],
        borderRadius: '3px'
    }
});
export var AutocompleteInput = function (_a) {
    var options = _a.options, _b = _a.freeSolo, freeSolo = _b === void 0 ? true : _b, _c = _a.autoSelect, autoSelect = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, id = _a.id, name = _a.name, onChange = _a.onChange, _e = _a.size, size = _e === void 0 ? 'small' : _e, placeholder = _a.placeholder, _f = _a.fullWidth, fullWidth = _f === void 0 ? true : _f, _g = _a.readOnly, readOnly = _g === void 0 ? false : _g, _h = _a.required, required = _h === void 0 ? false : _h, _j = _a.rows, rows = _j === void 0 ? 1 : _j, sx = _a.sx, type = _a.type, width = _a.width, value = _a.value;
    return (React.createElement(MyAutocomplete, { id: id, freeSolo: freeSolo, autoSelect: autoSelect, size: size, onChange: onChange, disabled: disabled, 
        // autoComplete
        readOnly: readOnly, options: options, value: value, fullWidth: fullWidth, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { name: name, fullWidth: fullWidth, placeholder: placeholder, sx: __assign({ fontFamily: 'IBM Plex Sans', width: width }, sx), required: required }))); } }));
};
